import Character from '../character';

import { Modules } from '@kaetram/common/network';

import type Game from '../../../game';

export default class Pet extends Character {
    public ownerInstance = '';

    public constructor(instance: string, game: Game) {
        super(instance, Modules.EntityType.Pet, game);
    }

    public override hasShadow(): boolean {
        return true;
    }

    public override drawNames(): boolean {
        return true;
    }
}
